import { ModuleSidebar } from '../../../../components/ui/ModuleSidebar';
import { ProductNavigation } from '../../../../components/ui/ProductNavigation';
import { findProductModule } from '../../../../components/ui/ProductNavigation/navigation-data';
import { IntentionStudentDetail } from './app/IntentionStudentDetail';
import styles from './Page.module.css';

const recruitmentModule = findProductModule('recruitment');

export function IntentionStudentV1Page() {
  return <main className={styles.page}>
    <ProductNavigation defaultActive="招生营销" />
    <div className={styles.workspace}>
      <ModuleSidebar activeItem="意向学员管理" ariaLabel="招生营销导航" groups={recruitmentModule?.groups ?? []} />
      <section aria-label="意向学员管理页面">
        <h1 className={styles.visuallyHidden}>意向学员管理</h1>
        <IntentionStudentDetail />
      </section>
    </div>
  </main>;
}
